import { Typography, Divider } from '@mui/material';
import Grid from '@mui/material/Grid';
import {
    SERVICE_FILTER_LABELS
} from 'constants/filterOptions';
import Box from '@mui/material/Box';
import React from 'react';
import CheckboxFilter from 'components/commons/CheckboxFilter';

function ServiceFilter(props) {
    return (
        <Box
            sx={{
                mb: 2,
                width: '100%',
            }}
        >
            <Typography sx={{ mb: 2.5, display: 'block' }} variant="text4" gutterBottom>Service</Typography>
            <Grid container>
                {
                    Object.keys(SERVICE_FILTER_LABELS).map((value) => {
                        return (
                            <Grid item size={4} key={value}>
                                <CheckboxFilter
                                    value={SERVICE_FILTER_LABELS[value]}
                                    comparableType={props.comparableType}
                                    attrName={value}
                                />
                            </Grid>
                        );
                    })
                }
            </Grid>
            <Divider orientation="horizontal" sx={{mb:3, mt:3}}/>
        </Box>
    );
}

export default React.memo(ServiceFilter);